export class PromiseHolder<ResultType> {
  private resolveCallback?: (result: ResultType) => void;
  private rejectCallback?: (error: Error) => void;

  private promise?: Promise<ResultType>;

  // TODO: check this
  init() {
    this.setPromise(
      new Promise((resolve, reject) => {
        this.setup(resolve, reject);
      }),
    );
  }

  private setup(resolve: (result: ResultType) => void, reject: (error: Error) => void) {
    this.resolveCallback = resolve;
    this.rejectCallback = reject;
  }

  resolve(result: ResultType) {
    if (this.resolveCallback === undefined) {
      throw new Error('Resolve callback not set');
    }

    this.resolveCallback(result);
  }

  reject(error: Error) {
    if (this.rejectCallback === undefined) {
      throw new Error('Reject callback not set');
    }

    this.rejectCallback(error);
  }

  setPromise(promise: Promise<ResultType>) {
    this.promise = promise;
  }

  getPromise(): Promise<ResultType> {
    if (this.promise === undefined) {
      throw new Error('Promise not set');
    }

    return this.promise;
  }
}
